import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { getTrustNGOAuthUrl } from "@/lib/trustngo-auth";

const footerLinks = {
  Services: [
    { label: "ISO Certifications", path: "/services/iso-certifications" },
    { label: "CSR & Impact", path: "/services/csr-impact" },
    { label: "Skill Development", path: "/services/skill-development" },
    { label: "Research & Surveys", path: "/services/research-surveys" },
    { label: "Management Consulting", path: "/services/management-consulting" },
  ],
  Opportunities: [
    { label: "Partnerships & Opportunities", path: "/partnerships" },
    { label: "Contact Us", path: "/contact" },
    { label: "Clients & Projects", path: "/clients" },
  ],
  Legal: [
    { label: "Privacy Policy", path: "/privacy" },
    { label: "Terms & Conditions", path: "/terms" },
    { label: "Refund Policy", path: "/refund" },
    { label: "Disclaimer", path: "/disclaimer" },
    { label: "FAQ", path: "/faq" },
  ],
};

export default function Footer() {
  const accountLinks = [
    { label: "Client Workspace Login", path: "/workspace" },
    { label: "Sign Up with TrustNGO SSO", href: getTrustNGOAuthUrl("signup", "/workspace") },
    { label: "Admin Login", path: "/admin/login" },
  ];

  return (
    <footer className="border-t border-border bg-primary text-primary-foreground">
      <div className="container-narrow section-padding">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent">
                <span className="font-heading text-lg font-bold text-accent-foreground">S</span>
              </div>
              <span className="font-heading text-lg font-bold">SigmaCert</span>
            </div>
            <p className="mb-6 text-sm leading-relaxed opacity-80">
              Certification, compliance, and tender-readiness discovery support for organizations exploring practical pathways and documentation readiness.
            </p>
            <div className="space-y-2 text-sm opacity-80">
              <div className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0" />
                <span>310, Wadhwa Complex, D-288-289/10, Laxmi Nagar Metro Station Gate No.1, Vikas Marg, Delhi - 110092</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 shrink-0" />
                <a href="tel:+918527243980">+91-8527243980</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 shrink-0" />
                <a href="mailto:sigmacert1@gmail.com">sigmacert1@gmail.com</a>
              </div>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="mb-4 font-heading text-sm font-semibold uppercase tracking-wider opacity-60">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm opacity-80 transition-opacity hover:opacity-100">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold uppercase tracking-wider opacity-60">Account</h4>
            <ul className="space-y-2">
              {accountLinks.map((link) => (
                <li key={link.label}>
                  {"href" in link ? (
                    <a href={link.href} className="text-sm opacity-80 transition-opacity hover:opacity-100">
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.path} className="text-sm opacity-80 transition-opacity hover:opacity-100">
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-primary-foreground/20 pt-6 text-center text-xs opacity-60 space-y-1">
          <p>© {new Date().getFullYear()} Sigma Certification Services Private Limited. All rights reserved.</p>
          <p className="opacity-80">Part of the TrustNGO Labs Growth Ecosystem.</p>
          <p className="opacity-80">
            Need guided execution support? Continue with GetSaarthi.
          </p>
        </div>
      </div>
    </footer>
  );
}
